
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const gameHistory = createAsyncThunk("user/gameHistory", async (payload) => {
  const response = await api.post("user/geme-history", payload);
 
  return response.data;
});

const gameHistorySlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  extraReducers: (builder) => {
    builder
      .addCase(gameHistory.pending, (state) => {
        
        state.loading = true;
      })
      .addCase(gameHistory.fulfilled, (state, action) => {
      
        
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(gameHistory.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default gameHistorySlice.reducer;
